<script>
import { apiSecond, urlApi } from '@/boot/axios'

import HeaderBack from '@/components/UI/HeaderBack.vue'
import ReportManageErrorModal from '@/components/reporting-management/ReportManageErrorModal.vue'

export default {
	name: 'ReportTirIndex10',
	components: {
		HeaderBack,
		ReportManageErrorModal,
	},
	head: {
		title() {
			return {
				inner: this.$t('sidebar.references'),
			}
		},
		meta: [],
	},
	data() {
		return {
			pageId: 10,
			applications: [],
			applicationsMeta: {},
			headers: [
				{ text: 'Id', value: 'id', width: '50px' },
				{ text: this.$t('headers.report_name'), value: 'name', width: '10vw' },
				{ text: this.$t('headers.report_send_data'), value: 'date_of_submission', width: '10vw' },
				{ text: this.$t('headers.send_period'), value: 'surrender_date', width: '10vw' },
				{
					text: this.$t('headers.action'),
					value: 'action',
					align: 'left',
					sortable: false,
					width: '200px',
				},
			],
			errorMessage: {
				status: null,
				messages: null,
				text: null,
			},
			message: {
				status: null,
				text: null,
			},

			test: ['jon', 'mike', 'jana', 'andre', 'vitaly'],
			urlApi: urlApi,
			v_model_name_search: '',
			v_model_region_search: '',
			v_model_pond_search: '',
			v_model_iin_search: '',
			quarter_value: '',
			inputYears: null,
			filter: [],
			options: {
				itemsPerPage: 10,
				page: 1,
			},
		}
	},
	computed: {
		filteredlist() {
			return this.applications
		},
	},
	watch: {
		v_model_name_search() {
			this.quarter_value = null
			this.$refs.region.value = null
			this.v_model_region_search = ''
			this.$refs.pond.value = null
			this.v_model_pond_search = ''
			this.$refs.quarter.value = null
			this.v_model_iin_search = ''
			//this.v_model_name_search=''
		},
		v_model_region_search() {
			this.quarter_value = null
			//this.$refs.region.value=null;
			//this.v_model_region_search='';
			this.$refs.pond.value = null
			this.v_model_pond_search = ''
			this.$refs.quarter.value = null
			this.v_model_iin_search = ''
			this.v_model_name_search = ''
		},
		v_model_pond_search() {
			this.quarter_value = null
			this.$refs.region.value = null
			this.v_model_region_search = ''
			//this.$refs.pond.value=null;
			//this.v_model_pond_search='';
			this.$refs.quarter.value = null
			this.v_model_iin_search = ''
			this.v_model_name_search = ''
		},
		v_model_iin_search() {
			this.quarter_value = null
			this.$refs.region.value = null
			this.v_model_region_search = ''
			this.$refs.pond.value = null
			this.v_model_pond_search = ''
			this.$refs.quarter.value = null
			//this.v_model_iin_search='';
			this.v_model_name_search = ''
		},
		quarter_value() {
			//this.quarter_value =null;
			this.$refs.region.value = null
			this.v_model_region_search = ''
			this.$refs.pond.value = null
			this.v_model_pond_search = ''
			//this.$refs.quarter.value=null;
			this.v_model_iin_search = ''
			this.v_model_name_search = ''
		},
	},
	methods: {
		downloadFile(id) {
			apiSecond
				.get(`v1/tir/archived/export/excel/${id}`)
				.then((response) => {
					let fileURL = window.URL.createObjectURL(new Blob([response.data]), {
						type: response.headers['content-type'],
					})
					let fileLink = document.createElement('a')
					fileLink.href = fileURL
					const extensions = {
						'application/excel': 'xls',
					}
					const contentType = response.headers['content-type']
					const extension = extensions[contentType]
					const filename = 'report.' + extension

					fileLink.setAttribute('download', filename)
					document.body.appendChild(fileLink)

					fileLink.click()
				})
				.catch((error) => {
					this.checkError(error)
				})
		},
		checkError(error) {
			if (error?.response?.status > 500) {
				this.errorMessage.status = 500
				this.errorMessage.text = this.$t('system_message.500')
			} else if (error?.response?.status == 401) {
				this.errorMessage.status = 401
				this.errorMessage.text = error?.response?.data?.message
				this.$router.push('/' + this.$i18n.locale + '/login')
			} else {
				this.errorMessage.status = 422
				this.errorMessage.text = error?.response?.data?.message
			}
			this.$modal.show('ReportManageErrorModal')
		},
		pagination(options) {
			this.apiGetReportingList(options.page, options.itemsPerPage)
		},
		async apiGetReportingList(page, per_page) {
			try {
				const response = await apiSecond.get(`v1/tir/archived/${this.pageId}`, {
					params: { page, per_page },
				})
				if (response.data) {
					this.applications = response.data.data
					this.applicationsMeta = response.data.meta
				}
			} catch (error) {
				this.checkError(error)
			}
		},
	},
	beforeCreate() {
		if (!localStorage.token) this.$router.push('/ru/login')
	},
}
</script>

<template>
	<div
		class="wrap__content"
		v-bind:class="{ 'wrap__content--preloader': !applications || !$store.state.userObject }"
	>
		<v-preloader
			v-if="!applications || !$store.state.userObject"
			:message="errorMessage"
		></v-preloader>

		<div class="container" v-if="applications && $store.state.userObject">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['ReportingManagement']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<HeaderBack :title="$t('titles.reporteds_10')" />
							<div class="card__content--body index-page">
								<div class="table__block--content">
									<div class="table__block--filter">
										<div class="table__filter--right">
											<router-link
												:to="'/' + $i18n.locale + '/account/reporting/10-tir-rh/list/2'"
												class="btn--link btn--link--plus ml-auto mt-3"
											>
												<!---{{ $t('button.add') }} --->
												{{ $t('titles.createing_reports') }}
												<img :src="require('@/assets/img/icon-plus.svg')" />
											</router-link>
											<router-link
												v-if="$store.getters.userPermission(['change_reporting-3rh'])"
												:to="'/' + $i18n.locale + '/account/reporting/' + 10 + '-rh' + '/create'"
												class="btn--link btn--link--plus"
											>
												{{ $t('button.add') }} <img :src="require('@/assets/img/icon-plus.svg')" />
											</router-link>
										</div>
									</div>

									<v-data-table
										:headers="headers"
										:items="filteredlist"
										:loading="false"
										:options.sync="options"
										:footer-props="{
											'items-per-page-options': [5, 10, 20, 30, 40, 50],
										}"
										:server-items-length="applicationsMeta.total"
										@update:options="pagination($event)"
									>
										<!---------------1-------------->
										<template v-slot:item.name="{ item }">
											<a class="tb__table--link" v-html="item.name"></a>
										</template>
										<!---------------2-------------->
										<template v-slot:item.archived="{ item }">
											<a class="tb__table--link">
												{{ !item.archived ? 'Создан' : 'В архиве' }}
											</a>
										</template>
										<!---------------3-------------->
										<template v-slot:item.action="{ item }">
											<div class="flex">
												<a
													class="table__link--exel"
													style="filter: grayscale(1) opacity(0.3)"
													@click.prevent="downloadFile(item.id)"
												>
													<svg width="64" height="24" viewBox="0 0 64 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M22.342 4.568h-8.76v2.703h2.022a.675.675 0 010 1.351h-2.022v1.352h2.022a.675.675 0 010 1.35h-2.022v1.352h2.022a.675.675 0 010 1.351h-2.022v1.352h2.022a.675.675 0 010 1.351h-2.022v2.703h8.76a.675.675 0 00.674-.676V5.244a.675.675 0 00-.674-.676zM19.647 16.73h-1.348a.675.675 0 010-1.351h1.348a.675.675 0 010 1.351zm0-2.703h-1.348a.675.675 0 010-1.35h1.348a.675.675 0 010 1.35zm0-2.702h-1.348a.675.675 0 010-1.351h1.348a.675.675 0 010 1.35zm0-2.703h-1.348a.675.675 0 010-1.351h1.348a.675.675 0 010 1.351zM12.87 2.021a.66.66 0 00-.555-.143L1.535 3.905a.674.674 0 00-.55.663v14.865c0 .324.23.604.55.663l10.78 2.027a.669.669 0 00.554-.143.675.675 0 00.244-.52V2.541a.675.675 0 00-.244-.521zm-2.682 13.19a.67.67 0 01-.95-.064l-1.96-2.245-1.718 2.216a.67.67 0 01-.948.119.678.678 0 01-.117-.949l1.879-2.421L4.52 9.742a.676.676 0 01.063-.952.669.669 0 01.95.064l1.682 1.926 1.996-2.573a.674.674 0 111.063.832L8.12 11.817l2.131 2.441a.676.676 0 01-.063.953z" fill="#207245"/><path d="M39.308 16.232V17h-5.94V8.6h5.76v.768h-4.872v2.988H38.6v.756h-4.344v3.12h5.052zM45.06 17l-2.004-2.64L41.04 17h-.96l2.496-3.24-2.376-3.072h.96l1.896 2.472 1.896-2.472h.936l-2.376 3.072 2.52 3.24h-.972zm4.783.06a3.436 3.436 0 01-1.68-.408 2.976 2.976 0 01-1.152-1.14 3.333 3.333 0 01-.42-1.668c0-.616.14-1.168.42-1.656.28-.488.664-.868 1.152-1.14a3.436 3.436 0 011.68-.408c.544 0 1.028.108 1.452.324.432.208.772.516 1.02.924l-.636.432a1.945 1.945 0 00-.792-.696c-.32-.16-.668-.24-1.044-.24-.456 0-.868.104-1.236.312-.36.2-.644.488-.852.864-.2.376-.3.804-.3 1.284 0 .488.1.92.3 1.296.208.368.492.656.852.864.368.2.78.3 1.236.3.376 0 .724-.076 1.044-.228.32-.152.584-.384.792-.696l.636.432c-.248.408-.588.72-1.02.936a3.304 3.304 0 01-1.452.312zm9.536-2.952H54.1c.048.656.3 1.188.756 1.596.456.4 1.032.6 1.728.6.392 0 .752-.068 1.08-.204.328-.144.612-.352.852-.624l.48.552c-.28.336-.632.592-1.056.768a3.507 3.507 0 01-1.38.264c-.648 0-1.224-.136-1.728-.408a3.038 3.038 0 01-1.164-1.152 3.267 3.267 0 01-.42-1.656c0-.616.132-1.168.396-1.656.272-.488.64-.868 1.104-1.14.472-.272 1-.408 1.584-.408a3.05 3.05 0 011.572.408c.464.272.828.652 1.092 1.14.264.48.396 1.032.396 1.656l-.012.264zm-3.048-2.736c-.608 0-1.12.196-1.536.588-.408.384-.64.888-.696 1.512h4.476c-.056-.624-.292-1.128-.708-1.512-.408-.392-.92-.588-1.536-.588zm4.794-3.276h.852V17h-.851V8.096z" fill="#000"/></svg>
												</a>
											</div>
										</template>
										<v-alert slot="no-results" :value="true" color="error">
											{{ $t('system_message.search') }}
										</v-alert>
									</v-data-table>

									<ReportManageErrorModal :message="message" :errorMessage="errorMessage" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
.reporting-btn .input-btn.form__line--btn {
	background: #157fee;
	width: 220px;
	height: 47px;
	padding: 0;
	justify-content: center;
	transition: background 1s ease;
}

.checkbox {
	display: flex;
	align-items: center;
	align-content: center;
	padding: 10px 0;
}

.custom-checkbox {
	position: absolute;
	z-index: -1;
	opacity: 0;
}

.custom-checkbox + label {
	width: 200px;
	font-family: 'Montserrat';
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	color: #0a091d;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.custom-checkbox + label::before {
	content: '';
	display: inline-block;
	width: 17px;
	height: 17px;
	flex-shrink: 0;
	flex-grow: 0;
	border-radius: 6px;
	margin-right: 0.5em;
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 50% 50%;
	border: 1.5px solid #157fee;
}

.table__block--filter {
	border-bottom: 1px solid #d3e7fb;
	display: block;
	padding: 30px;
}

.search-main {
	width: 100%;
}

.table__filter--search {
	width: 100%;
	margin: 0;
}

.search__label {
	display: block;
	width: 100%;
}

.table__filter--search label input {
	width: 100%;
}
</style>
